import { Dispatch, ReactNode, SetStateAction } from 'react';
import styled from 'styled-components';

import NavigationStyled from '../Navigation';

type SidebarProps = {
  className?: string;
  children?: ReactNode;
  isMenuClosed: boolean;
  setIsMenuClosed: Dispatch<SetStateAction<boolean>>;
};

const Sidebar = ({ className = '', children, isMenuClosed, setIsMenuClosed }: SidebarProps) => (
  <div className={className}>
    <NavigationStyled isMenuClosed={isMenuClosed} setIsMenuClosed={setIsMenuClosed} />
    {children}
  </div>
);

const SidebarStyled = styled(Sidebar)`
  width: 17rem;
  padding: 0.75rem;
  background-color: ${({ theme }) => theme.neutralBackgroundMedium};
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (min-width: 1620px) {
    width: 20rem;
  }
`;

export default SidebarStyled;
